import React, { useRef } from 'react';
import Slider from 'react-slick';

import leftArrow from '../../../content/media-library/icons/left-long-arrow.svg';
import rightArrow from '../../../content/media-library/icons/right-long-arrow.svg';

const Carousel = ({ options, slides, customButtons }) => {
  const carouselRef = useRef(null);

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true
  };

  const CarouselButtons = () => {
    return (
      <div className="carousel-buttons-row">
        <button
          className="carousel-button carousel-button--previous"
          onClick={() => carouselRef.current.slickPrev()}
          aria-label="previous slide"
        >
          <img src={leftArrow} alt="Previous post" /> Prev
        </button>
        <button
          className="carousel-button carousel-button--next"
          onClick={() => carouselRef.current.slickNext()}
          aria-label="next slide"
        >
          Next <img src={rightArrow} alt="Next post" />
        </button>
      </div>
    );
  };

  return (
    <>
      {customButtons && <CarouselButtons />}
      <Slider ref={(c) => (carouselRef.current = c)} className="carousel" {...{ ...settings, ...options }}>
        {slides}
      </Slider>
    </>
  );
};

export default Carousel;
